import Cookies from '../library/Cookies';

function init() {
  let cookie = new Cookies();

  const savedObjectsCookieName    = 'savedobjects';
  const bookmarkAddButtons        = Array.from(document.querySelectorAll('.bookmark--add'));
  const dataPropertyID            = 'data-propertyid';
  const cookieSaveHours           = 43800; // save for 5 years
  const bookmarkMessage           = document.querySelector('.propertytile__message--bookmark');

  const savedSearchCookieName      = 'savedsearchs';
  const savedSearchAddButtons     = Array.from(document.querySelectorAll('.propertysearch__savebutton, .mobilepropertyfilter__button--savesearch'));
  const savedSearchRemoveButtons  = Array.from(document.querySelectorAll('.button--savedsearch--remove'));
  const dataSearchURL             = 'data-searchurl';
  const savedsearchMessage        = document.querySelector('.savedsearch__message--bookmark');

  window.bookmarkCountElements     = Array.from(document.querySelectorAll('.bookmarkcount'));


  // bookmark objects
  if (bookmarkAddButtons) {
    let savedObjects = false;
    let savedObjectsPostIDs = [];

    // via user meta
    if (loggedIn && savedObjectsUserMeta) {
      savedObjects = savedObjectsUserMeta;
    // via cookie
    } else {
      savedObjects = cookie.get(savedObjectsCookieName);
    }

    savedObjectsPostIDs = (savedObjects) ? savedObjects.toString().split(',') : [];

    bookmarkAddButtons.map((button) => {
      let postID = button.closest(`[${dataPropertyID}]`).getAttribute(dataPropertyID);

      // precheck bookmark added
      if (savedObjectsPostIDs.some(id => id == postID)) {
        //check if its the singleview button or from tile
        if (button.classList.contains('bookmark--add--singleview')) {
          button.classList.add('bookmark--alreadyadded--singleview');
        } else {
          button.classList.add('bookmark--alreadyadded');
        }
      }

      button.addEventListener('click', (e) => {
        e.preventDefault();

        if (postID) {

          if (button.classList.contains('bookmark--page') && button.classList.contains('bookmark--alreadyadded')) {

            // objectid remove
            savedObjectsPostIDs.pop(postID);
            let savedObjectsIDCommaString = savedObjectsPostIDs.join(',');
            // via user meta
            if (loggedIn) {
              savedObjectsUserMeta = savedObjectsIDCommaString;
              ajaxUpdateUsermetaBookmarks('savedObjects', savedObjectsIDCommaString);
            // via cookie
            } else {
              cookie.set(savedObjectsCookieName, savedObjectsIDCommaString, cookieSaveHours);
              bookmarkCount(loggedIn, cookie, savedObjectsCookieName, savedSearchCookieName);
            }

            let propertyItem = button.closest(`[${dataPropertyID}]`);

            propertyItem.classList.add('propertytile__item--bookmarkremoved');
            setTimeout(() => {
              propertyItem.remove();
              if (window.propertyTileSwiper) {
                window.propertyTileSwiper.update();
              }

              if (bookmarkMessage && savedObjectsPostIDs < 1) {
                bookmarkMessage.classList.add('propertytile__message--bookmarkshow');
              }
            }, 600); // align with propertytile__item--bookmarkremoved transition speed

          } else if (button.classList.contains('bookmark--added') || button.classList.contains('bookmark--alreadyadded') || button.classList.contains('bookmark--alreadyadded--singleview')) {


           // objectid remove
            savedObjectsPostIDs.pop(postID);
            let savedObjectsIDCommaString = savedObjectsPostIDs.join(',');
            // via user meta
            if (loggedIn) {
              savedObjectsUserMeta = savedObjectsIDCommaString;
              ajaxUpdateUsermetaBookmarks('savedObjects', savedObjectsIDCommaString);
            // via cookie
            } else {
              cookie.set(savedObjectsCookieName, savedObjectsIDCommaString, cookieSaveHours);
              bookmarkCount(loggedIn, cookie, savedObjectsCookieName, savedSearchCookieName);
            }

            //let propertyItem = button.closest(`[${dataPropertyID}]`);

            button.classList.remove('bookmark--added');
            button.classList.remove('bookmark--alreadyadded');
            button.classList.remove('bookmark--alreadyadded--singleview');

          } else {

            // objectid add
            if (!savedObjectsPostIDs.some(id => id == postID)) {
              savedObjectsPostIDs.push(postID);
              let savedObjectsIDCommaString = savedObjectsPostIDs.join(',');
              // via user meta
              if (loggedIn) {
                savedObjectsUserMeta = savedObjectsIDCommaString;
                ajaxUpdateUsermetaBookmarks('savedObjects', savedObjectsIDCommaString, button);
                //check if its the singleview button or from tile
                if (button.classList.contains('bookmark--add--singleview')) {
                  button.classList.add('bookmark--loading--singleview');
                } else {
                  button.classList.add('bookmark--loading');
                }
              // via cookie
              } else {
                cookie.set(savedObjectsCookieName, savedObjectsIDCommaString, cookieSaveHours);
                bookmarkCount(loggedIn, cookie, savedObjectsCookieName, savedSearchCookieName);
                //check if its the singleview button or from tile
                if (button.classList.contains('bookmark--add--singleview')) {
                  button.classList.add('bookmark--added--singleview');
                } else {
                  button.classList.add('bookmark--added');
                }
              }

            }
          }

        }

        return false;
      });
    });
  }

  // bookmark searchs
  let savedsearch = false;
  let savedSearchURLs = [];
  // via user meta
  if (loggedIn) {
    savedsearch = savedSearchUserMeta;
  // via cookie
  } else {
    const savedsearchCookie = cookie.get(savedSearchCookieName);
    savedsearch = (savedsearchCookie) ? savedsearchCookie : '';
  }

  savedSearchURLs = (savedsearch) ? savedsearch.toString().split(',') : [];

  if (savedSearchAddButtons) {
    savedSearchAddButtons.map((button) => {
      let searchURL = window.location.href;
      // remove pager from url
      searchURL = removeURLParameter(searchURL, 'resultspage');

      // precheck search added
      if (savedSearchURLs.some(url => url == searchURL)) {
        button.classList.add('button--savedsearch--alreadyadded');
      }

      button.addEventListener('click', (e) => {
        e.preventDefault();

        // searchurl add
        if (!savedSearchURLs.some(url => url == searchURL)) {
          savedSearchURLs.push(searchURL);
          let savedSearchURLsCommaString = savedSearchURLs.join(',');
          // via user meta
          if (loggedIn) {
            savedSearchUserMeta = savedSearchURLsCommaString;
            ajaxUpdateUsermetaBookmarks('savedSearch', savedSearchURLsCommaString);
          // via cookie
          } else {
            cookie.set(savedSearchCookieName, savedSearchURLsCommaString, cookieSaveHours);
            bookmarkCount(loggedIn, cookie, savedObjectsCookieName, savedSearchCookieName);
          }
          button.classList.add('button--savedsearch--added');
        }

        return false;
      });
    });
  }

  if (savedSearchRemoveButtons) {
    savedSearchRemoveButtons.map((button) => {

      button.addEventListener('click', (e) => {
        e.preventDefault();

        // searchurl remove
        let savedSearchItem = button.closest(`[${dataSearchURL}]`);
        let searchURL = savedSearchItem.getAttribute(dataSearchURL);

        savedSearchURLs.pop(searchURL);
        let savedSearchURLsCommaString = savedSearchURLs.join(',');
        // via user meta
        if (loggedIn) {
          savedSearchUserMeta = savedSearchURLsCommaString;
          ajaxUpdateUsermetaBookmarks('savedSearch', savedSearchURLsCommaString);
        // via cookie
        } else {
          cookie.set(savedSearchCookieName , savedSearchURLsCommaString, cookieSaveHours);
          bookmarkCount(loggedIn, cookie, savedObjectsCookieName, savedSearchCookieName);
        }

        savedSearchItem.classList.add('savedsearch__item--bookmarkremoved');
        setTimeout(() => {
          savedSearchItem.remove();

          if (savedsearchMessage && savedSearchURLs.length === 0) {
            savedsearchMessage.classList.add('savedsearch__message--bookmarkshow');
          }
        }, 600); // align with propertytile__item--bookmarkremoved transition speed

      });
    });
  }

  function ajaxUpdateUsermetaBookmarks(metakey, metavalue, button = false) {

    // counter loading
    if (window.bookmarkCountElements) {
      window.bookmarkCountElements.map((count) => {
        count.classList.add('bookmarkcount--loading');
      });
    }

    // ajax stuff
    let data = new FormData();
        data.append('action', 'update_user_meta_bookmarks');
        data.append('metakey', metakey);
        data.append('metavalue', metavalue);

    fetch('/wp-admin/admin-ajax.php', {
      method: 'POST',
      credentials: 'same-origin',
      body: data,
    }).then(response => response.json()).then(function(response) {
      //console.log(response);
      if (window.bookmarkCountElements) {
        window.bookmarkCountElements.map((count) => {
          count.classList.remove('bookmarkcount--loading');
        });
      }
      if (button) {
        button.classList.remove('bookmark--loading');
        button.classList.add('bookmark--added');
      }
      bookmarkCount(loggedIn, cookie, savedObjectsCookieName, savedSearchCookieName);
    });
  }

  function removeURLParameter(url, parameter) {
    var urlparts= url.split('?');
    if (urlparts.length>=2) {
        var prefix= encodeURIComponent(parameter)+'=';
        var pars= urlparts[1].split(/[&;]/g);

        for (var i= pars.length; i-- > 0;) {
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }
        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
  }

  function bookmarkCount(loggedIn = false, cookie, savedObjectsCookieName, savedSearchCookieName) {
    let savedObjects        = 0;
    let savedSearch         = 0;
    let savedObjectsPostIDs = [];
    let savedSearchURLs     = [];

    if (window.bookmarkCountElements) {

      // via user meta
      if (loggedIn) {
        savedObjects  = savedObjectsUserMeta;
        savedSearch   = savedSearchUserMeta;
      // via cookie
      } else {
        savedObjects  = cookie.get(savedObjectsCookieName);
        savedSearch   = cookie.get(savedSearchCookieName);
      }

      savedObjectsPostIDs = (savedObjects)  ? savedObjects.toString().split(',')  : [];
      savedSearchURLs     = (savedSearch)   ? savedSearch.toString().split(',')   : [];

      window.bookmarkCountElements.map((count) => {
        count.innerHTML = savedObjectsPostIDs.length + savedSearchURLs.length;;
      });
    }
  }

  bookmarkCount(loggedIn, cookie, savedObjectsCookieName, savedSearchCookieName);
}

export default init;



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Bookmark.js